import { useSyncExternalStore } from 'react';
import { useLocation } from 'react-router';

import { pageurl } from '@/constants/pageurl';

import { useCancellationAlerting } from '../hooks/use-cancellation-alerting';
import { alertUi } from '../services/alert-ui';
import { cancellationAlerts } from '../services/cancellation-alerts';

/** Header bell for cancellation alerts. Hidden unless this user is alerted at all. */
const AlertBell = () => {
	const { eligible, capabilities } = useCancellationAlerting();
	const snapshot = useSyncExternalStore(cancellationAlerts.subscribe, cancellationAlerts.getSnapshot);
	const open = useSyncExternalStore(alertUi.subscribe, alertUi.isOpen);
	const explicit = useSyncExternalStore(alertUi.subscribe, alertUi.isExplicit);
	const { pathname } = useLocation();
	// Mirrors the host: on the Cancelled units page only a bell-opened stack is showing.
	const expanded = pathname.startsWith(pageurl.CANCELLED_UNITS) ? open && explicit : open;
	if (!eligible || !capabilities) return null;

	const count = snapshot.unread;
	const label = count > 0 ? `Cancelled polling units: ${count} new` : 'Cancelled polling units: no new alerts';

	return (
		<button
			type='button'
			className={`pc-bell${count > 0 ? ' pc-bell--unread' : ''}`}
			onClick={() => (expanded ? alertUi.setOpen(false) : alertUi.openFromBell())}
			aria-label={label}
			aria-expanded={expanded}
			aria-controls='pc-alert-host'
			title={label}
		>
			<svg
				width='18'
				height='18'
				viewBox='0 0 24 24'
				fill='none'
				aria-hidden='true'
			>
				<path
					d='M12 3 2.5 20h19L12 3Z'
					stroke='currentColor'
					strokeWidth='1.8'
					strokeLinejoin='round'
				/>
				<path
					d='M12 9.5v5M12 17.2v.3'
					stroke='currentColor'
					strokeWidth='1.8'
					strokeLinecap='round'
				/>
			</svg>
			{count > 0 ? (
				<span
					className='pc-bell__count'
					aria-hidden='true'
				>
					{count > 99 ? '99+' : count}
				</span>
			) : null}
		</button>
	);
};

export default AlertBell;
